/* ============================================================
   Neon Studio - JavaScript du theme.

   Principe tenu partout dans ce fichier : le site FONCTIONNE sans lui.
   Les variantes sont des boutons radio dans un vrai formulaire, le tri est
   un formulaire qui se soumet, le panier est un POST natif. Ce script ne
   fait qu'ameliorer. Une erreur ici ne doit jamais empecher une commande.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* -- Menu mobile ------------------------------------------------------ */
  var hdr = $('.hdr');
  var burger = $('[data-burger]');
  var nav = $('#nav-principal');
  if (burger && nav) {
    var basculer = function (ouvrir) {
      // Le tiroir est en position fixe : son point de depart depend du bas REEL de
      // l'en-tete, qui bouge avec le bandeau defilant au-dessus et l'etat du defilement.
      // On le mesure a l'ouverture plutot que de le supposer.
      if (ouvrir && hdr) {
        var bas = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom));
        document.documentElement.style.setProperty('--nav-top', bas + 'px');
      }
      nav.classList.toggle('is-open', ouvrir);
      burger.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
      burger.classList.toggle('--croix', ouvrir);
      // Bloque le defilement du corps : sans ca, faire glisser le tiroir fait bouger la
      // page derriere, et on se retrouve ailleurs en refermant le menu.
      document.body.classList.toggle('nav-ouvert', ouvrir);
      burger.setAttribute('aria-label', ouvrir ? 'Fermer le menu' : 'Ouvrir le menu');
    };

    burger.addEventListener('click', function () {
      basculer(!nav.classList.contains('is-open'));
    });

    // Fermer en suivant un lien : sans ca, le tiroir reste ouvert par-dessus la page
    // d'arrivee, et on croit que le clic n'a pas fonctionne.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) basculer(false);
    });

    // Echap ferme, comme tout panneau modal.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        basculer(false);
        burger.focus();
      }
    });

    // Retour au grand ecran : le tiroir doit rendre la main, sinon la navigation reste
    // masquee alors que la barre a repris sa forme horizontale.
    var large = window.matchMedia('(min-width: 1025px)');
    var surLargeur = function (m) { if (m.matches) basculer(false); };
    if (large.addEventListener) large.addEventListener('change', surLargeur);
    else if (large.addListener) large.addListener(surLargeur);
  }

  /* -- Reveal au defilement ----------------------------------------------
     La classe .js-anim n'est posee QUE si le navigateur sait observer : sans elle,
     animations.css laisse tout visible. C'est le defaut a eviter absolument sur une
     boutique , une page dont le contenu reste invisible parce qu'un script a echoue
     ne vend rien, et personne ne s'en apercoit avant de lire les statistiques.       */
  var bouge = true;
  try { bouge = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* -- Revelation au defilement ------------------------------------------
     Chaque bloc recoit une variable --p, de 0 a 1, selon sa position dans le cadre.
     Tout le rendu en decoule cote CSS. L'animation SUIT donc le defilement au lieu
     d'etre declenchee par lui : elle se rejoue a l'envers en remontant, et s'arrete
     ou l'on s'arrete.

     Calcul volontairement simple : la progression demarre quand le bloc est DEJA entre
     de 12 % dans le cadre, et atteint 1 lorsqu'il est remonte de la moitie de la
     hauteur. Ce retard au demarrage est voulu , sans lui, un bloc commence a se reveler
     alors qu'il affleure a peine le bas de l'ecran, et l'effet passe inapercu. Ce qui
     est hors cadre est ignore.

     Le travail par image est borne par un rAF : le defilement emet des dizaines
     d'evenements par seconde, on n'en garde qu'un par image affichee. Et l'on ne
     recalcule que les blocs REELLEMENT dans le cadre, elargi d'une hauteur d'ecran,
     donc quelques elements a la fois quel que soit le nombre sur la page.            */
  /* MOBILE : aucune animation, et surtout aucun calcul.

     Ce n'est pas qu'une question de gout. Sur telephone, ces blocs arrivent presque
     toujours seuls a l'ecran : la revelation se joue avant meme qu'on ait fini de faire
     glisser le doigt, donc elle ne se voit pas. En face, elle coute un calcul de
     position par image sur les appareils les moins puissants, pendant le defilement,
     c'est-a-dire au pire moment.

     On ne pose donc pas .js-anim : sans elle, aucune regle de masquage ne s'applique,
     la page s'affiche entiere, et ni ecouteur ni intervalle ne sont installes. */
  var surTelephone = false;
  try { surTelephone = window.matchMedia('(max-width: 759px)').matches; } catch (e) {}

  if (bouge && !surTelephone) {
    var blocsAnimes = $$('[data-anim]').filter(function (el) {
      return el.getAttribute('data-anim') !== 'hero';
    });

    if (blocsAnimes.length) {
      document.documentElement.classList.add('js-anim');

      var enCours = false;
      var majProgression = function (tout) {
        enCours = false;
        var hCadre = window.innerHeight || document.documentElement.clientHeight;
        for (var iBloc = 0; iBloc < blocsAnimes.length; iBloc++) {
          var el = blocsAnimes[iBloc];
          var rBloc = el.getBoundingClientRect();
          /* On ignore ce qui est loin du cadre , sauf au tout premier passage.

             Sans cette exception, un bloc situe tres bas gardait la valeur par defaut,
             c'est-a-dire 1, donc pleinement visible ; en arrivant dans la zone calculee
             il retombait d'un coup a 0 avant de se reveler. Le contenu clignotait. Au
             premier passage on calcule donc TOUT, une seule fois, et l'on repasse
             ensuite sur la fenetre glissante. */
          if (!tout && (rBloc.bottom < -hCadre || rBloc.top > hCadre * 2)) continue;
          var prog = (hCadre * 0.88 - rBloc.top) / (hCadre * 0.5);
          if (prog < 0) prog = 0;
          if (prog > 1) prog = 1;
          el.style.setProperty('--p', prog.toFixed(3));
        }
      };
      var demander = function () {
        if (enCours) return;
        enCours = true;
        window.requestAnimationFrame(majProgression);
      };

      majProgression(true);
      window.addEventListener('scroll', demander, { passive: true });
      window.addEventListener('resize', demander);

      /* Ceinture ET bretelles : on verifie aussi la position toutes les 200 ms.

         L'evenement `scroll` peut ne jamais arriver , page pilotee, defilement pris en
         charge par le compositeur seul, extension qui l'intercepte. Constate ici meme :
         la page se deplacait, --p restait fige, et le texte restait a 20 % d'opacite.
         Un contenu a moitie visible et bloque est pire que pas d'animation du tout.

         Le cout est negligeable : cinq comparaisons de nombres par seconde, et aucun
         calcul de mise en page tant que la position n'a pas change. */
      var dernierY = -1;
      window.setInterval(function () {
        var yPos = window.pageYOffset || document.documentElement.scrollTop;
        if (yPos === dernierY) return;
        dernierY = yPos;
        demander();
      }, 200);

      /* FILET DE SECURITE. La regle numero un du fichier d'animations dit qu'une
         animation ne doit jamais masquer durablement du contenu. Comme .js-anim vient
         d'etre posee, on en devient responsable : si le calcul echouait, tout resterait
         invisible. Au bout de 2,5 s, on verifie qu'au moins un bloc a progresse ; sinon
         on remet tout a 1 et on cesse d'ecouter. */
      window.setTimeout(function () {
        /* On ne se contente pas de « une valeur a ete posee » : un bloc encore sous la
           ligne de flottaison a legitimement une progression basse. On verifie qu'un
           bloc REELLEMENT visible est arrive au bout. Sinon le calcul ne suit pas, et
           il vaut mieux tout montrer. */
        var h2 = window.innerHeight || document.documentElement.clientHeight;
        var bon = blocsAnimes.some(function (el) {
          var rVu = el.getBoundingClientRect();
          if (rVu.top > h2 * 0.5 || rVu.bottom < 0) return false;
          return parseFloat(el.style.getPropertyValue('--p')) >= 0.9;
        });
        if (bon) return;
        window.removeEventListener('scroll', demander);
        blocsAnimes.forEach(function (el) { el.style.setProperty('--p', '1'); });
      }, 2500);
    }
  }

  /* -- En-tete escamotable ------------------------------------------------
     Se retracte quand on descend, revient des qu'on remonte : sur mobile, un
     en-tete de 70 px fixe mange un cinquieme de l'ecran pendant toute la lecture.
     Le seuil evite qu'il clignote sur les micro-defilements du pouce.            */
  if (hdr) {
    var bloque = false;
    // L'entete reste visible en permanence. Elle se contentait autrefois de se retracter
    // au defilement vers le bas ; sur une boutique, le panier et la recherche doivent
    // rester atteignables sans avoir a remonter, et le gain de hauteur ne le justifie pas.
    // Seule l'ombre apparait, pour detacher la barre du contenu qui passe dessous.
    var majEntete = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      hdr.classList.toggle('--pose', y > 8);
      bloque = false;
    };
    window.addEventListener('scroll', function () {
      // rAF plutot qu'un ecouteur direct : le defilement declenche des dizaines
      // d'evenements par seconde, on n'en garde qu'un par image affichee.
      if (bloque) return;
      bloque = true;
      window.requestAnimationFrame(majEntete);
    }, { passive: true });
  }

  /* -- Bandeau cookies ---------------------------------------------------
     Le choix est garde en localStorage et NON en cookie : deposer un cookie
     pour retenir un refus de cookies est exactement ce que la regle interdit.
     Le bandeau reste masque par l'attribut hidden tant qu'on n'a pas verifie,
     ce qui evite qu'il clignote a chaque page pour qui a deja repondu.        */
  var ck = document.getElementById('bandeau-cookies');
  if (ck) {
    var CLE = 'ck-ok';
    var vu = false;
    try { vu = localStorage.getItem(CLE) === '1'; } catch (e) { vu = false; }
    if (!vu) {
      ck.hidden = false;
      var okBtn = ck.querySelector('[data-ck-ok]');
      if (okBtn) {
        okBtn.addEventListener('click', function () {
          ck.hidden = true;
          try { localStorage.setItem(CLE, '1'); } catch (e) {}
        });
      }
    }
  }

  /* -- Mega-menu au clavier ----------------------------------------------
     Le survol suffit a la souris (CSS pur), mais pas au clavier ni au tactile.
     On bascule aria-expanded sur le lien parent pour que l'etat soit annonce. */
  $$('[data-mega]').forEach(function (m) {
    var lien = $('.hdr__lien', m);
    if (!lien) return;
    var majAria = function (ouvert) { lien.setAttribute('aria-expanded', ouvert ? 'true' : 'false'); };
    m.addEventListener('mouseenter', function () { majAria(true); });
    m.addEventListener('mouseleave', function () { majAria(false); });
    m.addEventListener('focusin', function () { majAria(true); });
    m.addEventListener('focusout', function () {
      if (!m.contains(document.activeElement)) majAria(false);
    });
  });

  /* -- Tri et filtres des collections ------------------------------------
     L'ecoute est posee sur le FORMULAIRE, pas sur le <select> : le meme
     formulaire porte desormais le tri et les cases des filtres natifs, et
     "change" remonte depuis n'importe lequel de ses champs. Un seul
     ecouteur couvre donc les deux, et un champ ajoute plus tard marchera
     sans qu'on y revienne.
     Le bouton de repli reste dans un <noscript>, donc personne n'est bloque. */
  var formTri = $('[data-tri]');
  if (formTri) {
    formTri.addEventListener('change', function () { formTri.submit(); });
  }

  /* -- Carrousel des avis -------------------------------------------------
     Les fleches ne font que deplacer le defilement natif du conteneur : aucun
     index a tenir, aucune borne a recalculer au redimensionnement. Le pas est
     mesure sur une carte reelle plutot que code en dur, donc il suit la
     largeur du moment.                                                      */
  var pisteAvis = $('[data-avis-piste]');
  if (pisteAvis) {
    var pasAvis = function () {
      var carte = $('.avis__c', pisteAvis);
      return carte ? carte.getBoundingClientRect().width + 30 : 260;
    };
    var flPrec = $('[data-avis-prec]');
    var flSuiv = $('[data-avis-suiv]');

    /* Les fleches BOUCLENT. Arrivee au dernier avis, la fleche droite ramene au premier
       plutot que de ne rien faire : un bouton qui reste visible et cliquable mais devenu
       inerte se lit comme une panne. Meme raisonnement a gauche, en sens inverse.

       ATTENTION , scrollWidth - clientWidth N'EST PAS la fin atteignable. Avec
       scroll-snap-type: x mandatory, le navigateur recale sur le debut de la derniere
       carte : mesure faite le 7 septembre, la piste s'arretait a 98 px alors que
       scrollWidth - clientWidth valait 165. Un test contre cette valeur n'est donc JAMAIS
       vrai, et c'est pourquoi ni la fleche ni le defilement automatique ne rebouclaient.

       On regarde a la place si la DERNIERE CARTE est entierement visible : c'est ce que
       « on est au bout » veut dire pour l'oeil, et ca reste vrai quel que soit le calage.

       La mesure passe par getBoundingClientRect et NON par offsetLeft. offsetLeft se
       compte depuis l'ancetre positionne , ici .avis__zone, qui contient aussi la fleche
       gauche et sa gouttiere , alors que le defilement, lui, se compte depuis la piste.
       Comparer les deux revenait a se tromper de la largeur d'une fleche. Les rectangles
       sont dans le meme repere ecran des deux cotes, donc la question ne se pose plus. */
    var auBout = function () {
      var cartes = pisteAvis.querySelectorAll('.avis__c');
      if (!cartes.length) return true;
      var bordCarte = cartes[cartes.length - 1].getBoundingClientRect().right;
      var bordPiste = pisteAvis.getBoundingClientRect().right;
      return bordCarte <= bordPiste + 4;
    };
    var glisser = function (sens) {
      if (sens > 0 && auBout()) pisteAvis.scrollTo({ left: 0, behavior: 'smooth' });
      else if (sens < 0 && pisteAvis.scrollLeft <= 4) pisteAvis.scrollTo({ left: pisteAvis.scrollWidth, behavior: 'smooth' });
      else pisteAvis.scrollBy({ left: sens * pasAvis() * 2, behavior: 'smooth' });
    };
    if (flPrec) flPrec.addEventListener('click', function () { glisser(-1); });
    if (flSuiv) flSuiv.addEventListener('click', function () { glisser(1); });

    /* Defilement automatique, une carte a la fois.

       Trois garde-fous, et chacun repond a une facon reelle de rater ce genre de
       carrousel :
       , il s'ARRETE au survol et au focus clavier , un contenu qui file pendant qu'on
         le lit est une brimade, et impossible a atteindre a la souris ;
       , il ne DEMARRE PAS si la personne a demande moins d'animation ;
       , il ne tourne que si la piste deborde reellement , avec quatre avis pour quatre
         places, il n'y a rien a faire defiler et un mouvement serait du bruit.

       Le retour au debut passe par auBout(), le meme test que les fleches : voir la note
       ci-dessus sur le calage, qui empechait ce reenroulement de se declencher. */
    var autoAvis = null;
    var douxAvis = true;
    try { douxAvis = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    var deborde = function () { return pisteAvis.scrollWidth - pisteAvis.clientWidth > 4; };

    var demarrer = function () {
      if (autoAvis || !douxAvis || !deborde()) return;
      autoAvis = window.setInterval(function () {
        if (auBout()) pisteAvis.scrollTo({ left: 0, behavior: 'smooth' });
        else pisteAvis.scrollBy({ left: pasAvis(), behavior: 'smooth' });
      }, 3200);
    };
    var arreter = function () { if (autoAvis) { window.clearInterval(autoAvis); autoAvis = null; } };

    pisteAvis.addEventListener('mouseenter', arreter);
    pisteAvis.addEventListener('mouseleave', demarrer);
    pisteAvis.addEventListener('focusin', arreter);
    pisteAvis.addEventListener('focusout', demarrer);
    if (flPrec) flPrec.addEventListener('click', arreter);
    if (flSuiv) flSuiv.addEventListener('click', arreter);

    /* On ne fait tourner que ce qui est a l'ecran : un carrousel qui defile en bas de
       page pendant qu'on lit le haut consomme sans que personne le voie. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) demarrer(); else arreter();
      }, { threshold: 0.25 }).observe(pisteAvis);
    } else {
      demarrer();
    }
  }

  /* -- « Charger plus » de la page Avis -----------------------------------
     Les cartes du lot suivant sont deja dans la page, simplement masquees en
     display:none : leurs photos, en loading="lazy", ne sont donc pas demandees au
     serveur tant qu'on ne les revele pas. C'est la tout le gain , pas le HTML, qui
     ne pese rien, mais les vingt images qu'on evite de telecharger d'emblee.

     Le lot est lu sur la piste (data-avis-lot) plutot que fixe ici : le reglage vit
     dans l'editeur de theme, et le script n'a pas a le connaitre.

     On ne remet pas le focus sur la premiere carte revelee : la personne vient de
     cliquer, deplacer son focus la ferait sauter la page sous ses yeux. Le bouton
     disparait quand il n'y a plus rien a montrer, ce qui suffit a dire que c'est fini. */
  var zonePlus = $('[data-avis-charger]');
  var btnPlus = $('[data-avis-plus]');
  if (zonePlus && btnPlus) {
    btnPlus.addEventListener('click', function () {
      var piste = $('[data-avis-piste]');
      if (!piste) return;
      var lot = parseInt(piste.getAttribute('data-avis-lot'), 10) || 8;
      var caches = piste.querySelectorAll('.avis__c--plus');
      var n = Math.min(lot, caches.length);
      for (var k = 0; k < n; k++) caches[k].classList.remove('avis__c--plus');

      var restant = caches.length - n;
      if (restant > 0) {
        var nb = $('[data-avis-reste]', zonePlus);
        if (nb) nb.textContent = String(restant);
      } else {
        zonePlus.remove();
      }
    });
  }

  /* -- Vente additionnelle a l'ajout au panier ---------------------------
     On intercepte l'envoi du formulaire d'achat, on poste sur /cart/add.js,
     puis on ouvre la fenetre qui propose le complement.

     Le formulaire reste un ENVOI CLASSIQUE tant que ce bloc n'a pas pris la
     main : sans JavaScript, ou si la requete echoue, on laisse le navigateur
     faire son travail et on atterrit sur la page panier. Un ajout au panier
     qui depend du script est une vente perdue en silence.

     La fenetre n'existe dans le balisage que si un complement DISPONIBLE a ete
     trouve cote Liquid, et le Liquid ne la pose que sur les produits d'une
     collection a complement. C'est ce qui la limite aux planches sans aucun
     test de type ici : le serveur a deja tranche.                          */
  var vente = $('[data-vente]');
  var formAchat = $('.pdp__form');
  if (vente && formAchat) {
    var ouvrirVente = function (o) {
      vente.hidden = !o;
      document.body.classList.toggle('pop-ouvert', o);
    };

    formAchat.addEventListener('submit', function (e) {
      var donneesAchat = new FormData(formAchat);
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: donneesAchat, headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout refuse');
          ouvrirVente(true);
        })
        .catch(function () {
          // Repli : on renvoie le formulaire pour de vrai, sans nous.
          formAchat.submit();
        });
    });

    $$('[data-vente-fermer]').forEach(function (b) {
      b.addEventListener('click', function () { ouvrirVente(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !vente.hidden) ouvrirVente(false);
    });

    var ajouterComp = $('[data-vente-ajouter]');
    if (ajouterComp) {
      ajouterComp.addEventListener('click', function () {
        ajouterComp.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(ajouterComp.getAttribute('data-vente-ajouter')), quantity: 1 }] })
        }).then(function () { window.location.href = '/cart'; })
          .catch(function () { window.location.href = '/cart'; });
      });
    }
  }

  /* -- Barre d'achat collante (fiche produit, telephone) ------------------
     Elle ne s'affiche qu'une fois le bouton principal sorti de l'ecran : sinon on
     montre deux fois le meme bouton, ce qui brouille plus qu'il n'aide. Le bouton
     de la barre soumet le VRAI formulaire, il ne duplique aucune logique d'achat. */
  var barre = $('[data-pdp-barre]');
  var ajoutPrincipal = $('[data-pdp-add]');
  if (barre && ajoutPrincipal && 'IntersectionObserver' in window) {
    var oBarre = new IntersectionObserver(function (e) {
      barre.hidden = e[0].isIntersecting || e[0].boundingClientRect.top > 0;
    }, { threshold: 0 });
    oBarre.observe(ajoutPrincipal);

    var relais = $('[data-pdp-barre-ajout]');
    if (relais) {
      relais.addEventListener('click', function () {
        var f = ajoutPrincipal.closest('form');
        if (f) { if (f.requestSubmit) f.requestSubmit(ajoutPrincipal); else ajoutPrincipal.click(); }
      });
    }
  }

  /* -- Fenetre d'inscription ----------------------------------------------
     Trois memoires distinctes, et c'est ce qui evite le harcelement :
     , INSCRIT (permanent)  : la personne a donne son adresse, elle ne reverra jamais
       la fenetre, sur aucun appareil ou le navigateur garde le stockage ;
     , FERME (date)         : elle a refuse. On note QUAND, et on ne repropose pas
       avant le nombre de jours regle ;
     , ARRIVEE (session)    : l'horodatage du premier chargement. Le delai se compte
       depuis l'arrivee sur le SITE, pas sur la page , sans cela, quelqu'un qui
       parcourt cinq pages en dix secondes la verrait surgir cinq fois. */
  var pop = $('[data-pop]');
  if (pop) {
    var K_INSCRIT = 'lemelle.pop.inscrit';
    var K_FERME   = 'lemelle.pop.ferme';
    var K_ARRIVEE = 'lemelle.pop.arrivee';

    // Un navigateur en navigation privee peut refuser le stockage : on ne doit jamais
    // planter pour autant, quitte a ce que la fenetre reapparaisse.
    var lire = function (magasin, cle) { try { return magasin.getItem(cle); } catch (e) { return null; } };
    var noter = function (magasin, cle, val) { try { magasin.setItem(cle, val); } catch (e) {} };

    var jours = parseInt(pop.getAttribute('data-jours') || '30', 10);
    var delai = parseInt(pop.getAttribute('data-delai') || '10', 10);
    var sortie = pop.getAttribute('data-sortie') === 'true';

    var confirme = !!pop.querySelector('[data-pop-ok]');
    var inscrit = lire(localStorage, K_INSCRIT) === '1';
    var quand = parseInt(lire(localStorage, K_FERME) || '0', 10);
    var enRepos = quand > 0 && (Date.now() - quand) < jours * 86400000;

    // Jamais pendant un achat : interrompre quelqu'un dans le tunnel coute une commande,
    // pas une adresse.
    // indexOf plutot qu'une expression reguliere : les antislashs d'echappement se
    // perdent trop facilement quand ce fichier est genere, et une regex a moitie
    // mangee devient un commentaire de ligne qui avale la suite du script.
    var chemin = window.location.pathname;
    var enAchat = chemin.indexOf('/cart') >= 0 || chemin.indexOf('/checkout') >= 0;

    var rendu = null;
    var ouvrir = function () {
      if (!pop.hidden) return;
      rendu = document.activeElement;
      pop.hidden = false;
      document.body.classList.add('pop-ouvert');
      var cible = pop.querySelector('#pop-email') || pop.querySelector('[data-pop-fermer]');
      if (cible) cible.focus();
    };
    var fermer = function (memoriser) {
      if (pop.hidden) return;
      pop.hidden = true;
      document.body.classList.remove('pop-ouvert');
      if (memoriser) noter(localStorage, K_FERME, String(Date.now()));
      if (rendu && rendu.focus) rendu.focus();
    };

    $$('[data-pop-fermer]', pop).forEach(function (b) {
      b.addEventListener('click', function () { fermer(true); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) fermer(true);
    });

    if (confirme) {
      // Retour du formulaire : on affiche le remerciement et le code, et on retient
      // l'inscription pour de bon.
      noter(localStorage, K_INSCRIT, '1');
      ouvrir();
    } else if (!inscrit && !enRepos && !enAchat) {
      var arrivee = parseInt(lire(sessionStorage, K_ARRIVEE) || '0', 10);
      if (!arrivee) { arrivee = Date.now(); noter(sessionStorage, K_ARRIVEE, String(arrivee)); }
      var reste = Math.max(0, delai * 1000 - (Date.now() - arrivee));
      var minuteur = setTimeout(ouvrir, reste);

      if (sortie) {
        document.addEventListener('mouseout', function surSortie(e) {
          // clientY <= 0 : la souris quitte par le HAUT, vers les onglets. Sortir par
          // les cotes ou le bas ne signifie pas un depart.
          if (e.clientY > 0 || e.relatedTarget) return;
          clearTimeout(minuteur);
          document.removeEventListener('mouseout', surSortie);
          ouvrir();
        });
      }
    }
  }

  /* -- Vitrine defilante --------------------------------------------------
     Les commandes sont dans le HTML mais posees en hidden : c'est ICI qu'on les revele.
     Sans script, on garde donc une premiere diapositive entiere et cliquable plutot que
     des fleches qui ne repondent pas , un bouton mort est pire qu'un bouton absent. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-vitrine]'), function (vit) {
    var dias = vit.querySelectorAll('[data-vit-dia]');
    if (dias.length < 2) return;

    var prec = vit.querySelector('[data-vit-prec]');
    var suiv = vit.querySelector('[data-vit-suiv]');
    var zone = vit.querySelector('[data-vit-pastilles]');
    var pastilles = zone ? zone.querySelectorAll('[data-vit-va]') : [];
    [prec, suiv, zone].forEach(function (el) { if (el) el.hidden = false; });

    var i = 0;
    var va = function (n) {
      i = (n + dias.length) % dias.length;
      Array.prototype.forEach.call(dias, function (d, k) { d.classList.toggle('--actif', k === i); });
      Array.prototype.forEach.call(pastilles, function (b, k) {
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    };

    if (prec) prec.addEventListener('click', function () { va(i - 1); });
    if (suiv) suiv.addEventListener('click', function () { va(i + 1); });
    Array.prototype.forEach.call(pastilles, function (b) {
      b.addEventListener('click', function () { va(parseInt(b.getAttribute('data-vit-va'), 10)); });
    });

    // Fleches du clavier : le carrousel doit s'utiliser sans souris.
    vit.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { va(i - 1); }
      if (e.key === 'ArrowRight') { va(i + 1); }
    });

    // Balayage au doigt. 45 px de seuil : en dessous, un simple appui fait defiler.
    var depart = null;
    vit.addEventListener('touchstart', function (e) { depart = e.touches[0].clientX; }, { passive: true });
    vit.addEventListener('touchend', function (e) {
      if (depart === null) return;
      var ecart = e.changedTouches[0].clientX - depart;
      if (Math.abs(ecart) > 45) { va(ecart < 0 ? i + 1 : i - 1); }
      depart = null;
    }, { passive: true });
  });

  /* -- Hauteur du bandeau d'annonce --------------------------------------
     Elle conditionne le decalage collant de l'en-tete. Mesuree plutot que codee en dur :
     le marchand peut changer le texte, et un retour a la ligne sur telephone double la
     hauteur du bandeau. */
  var bandeau = document.getElementById('shopify-section-bandeau');
  if (bandeau) {
    var majBandeau = function () {
      document.documentElement.style.setProperty('--bandeau-h', bandeau.offsetHeight + 'px');
    };
    majBandeau();
    window.addEventListener('resize', majBandeau);
  }

  /* -- Sous-menus depliables du tiroir mobile ----------------------------
     Le bouton est distinct du lien parent : sinon on ne peut plus atteindre la page
     "Boutique" elle-meme depuis un telephone, on ne fait que deplier son sous-menu. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-deplier]'), function (bouton) {
    bouton.addEventListener('click', function () {
      var bloc = bouton.closest('[data-mega]');
      if (!bloc) return;
      var ouvert = bloc.classList.toggle('--ouvert');
      bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    });
  });

  /* -- Selecteur pays / devise / langue ----------------------------------
     Le formulaire fonctionne seul grace a son bouton. On ne masque ce bouton QUE si le
     script tourne, et on soumet au changement : c'est le comportement attendu, sans
     jamais rendre le selecteur inutilisable quand le script echoue. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-loc-ok]'), function (ok) {
    ok.hidden = true;
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-loc-select]'), function (select) {
    select.addEventListener('change', function () {
      var formOption = select.closest('form');
      if (formOption) formOption.submit();
    });
  });

  /* -- Galerie de la fiche produit --------------------------------------
     Les vignettes restent la source de verite : les fleches ne font que
     deplacer le curseur dans CETTE liste, elles ne connaissent aucune image
     par elles-memes. Une vue ajoutee au produit est donc prise en compte
     partout sans toucher a ce bloc.                                        */
  var thumbs = $$('[data-pdp-thumb]');
  if (thumbs.length) {
    var principale = $('[data-pdp-main] img');
    var courante = 0;

    var montrer = function (i) {
      if (!principale) return;
      courante = (i + thumbs.length) % thumbs.length;   // boucle aux deux bouts
      var b = thumbs[courante];
      principale.src = b.getAttribute('data-full');
      principale.removeAttribute('srcset');
      thumbs.forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
    };

    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { montrer(i); });
    });

    /* Les fleches sont posees `hidden` dans le Liquid et revelees ici : sans
       script elles ne feraient rien, et un bouton inerte vaut moins que pas
       de bouton. Les vignettes, elles, fonctionnent dans les deux cas.      */
    var precVue = $('[data-pdp-prec]');
    var suivVue = $('[data-pdp-suiv]');
    if (precVue && suivVue && thumbs.length > 1) {
      precVue.hidden = false;
      suivVue.hidden = false;
      precVue.addEventListener('click', function () { montrer(courante - 1); });
      suivVue.addEventListener('click', function () { montrer(courante + 1); });

      // Fleches du clavier, quand le regard est deja sur la galerie.
      var media = $('.pdp__media');
      if (media) {
        media.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { montrer(courante - 1); }
          else if (e.key === 'ArrowRight') { montrer(courante + 1); }
        });
      }
    }
  }

  /* -- Variantes ---------------------------------------------------------
     On interroge le produit via son URL en .js : c'est l'endpoint officiel
     de Shopify, il renvoie l'etat REEL du stock et du prix. Reconstruire ces
     donnees a la main dans le Liquid conduit tot ou tard a vendre un article
     epuise, parce que la page est mise en cache et le stock non.            */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var champVariante = $('[data-pdp-variant]', pdp);
    var boutonAjout = $('[data-pdp-add]', pdp);
    var zonePrix = $('[data-pdp-price]', pdp);
    var options = $$('[data-pdp-option]', pdp);
    var donnees = null;

    var charger = function () {
      if (donnees) return Promise.resolve(donnees);
      return fetch(pdp.getAttribute('data-url') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { donnees = d; return d; })
        .catch(function () { return null; });
    };

    var choisies = function () {
      var v = [];
      options.forEach(function (i) { if (i.checked) v.push(i.value); });
      return v;
    };

    var argent = function (centimes) {
      // Format minimal : Shopify n'expose pas money cote client. On garde la
      // devise de la boutique via Intl, sinon on retombe sur un affichage brut.
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
        }).format(centimes / 100);
      } catch (e) { return (centimes / 100).toFixed(2); }
    };

    var majuscule = function () {
      charger().then(function (d) {
        if (!d || !d.variants) return;
        var vals = choisies();
        var trouvee = null;
        d.variants.forEach(function (v) {
          if (trouvee) return;
          var ok = true;
          vals.forEach(function (val, i) { if (v.options[i] !== val) ok = false; });
          if (ok) trouvee = v;
        });

        if (!trouvee) {
          if (boutonAjout) { boutonAjout.disabled = true; boutonAjout.textContent = boutonAjout.getAttribute('data-epuise') || boutonAjout.textContent; }
          return;
        }

        if (champVariante) champVariante.value = trouvee.id;
        if (boutonAjout) boutonAjout.disabled = !trouvee.available;
        if (zonePrix) {
          var html = '';
          if (trouvee.compare_at_price && trouvee.compare_at_price > trouvee.price) {
            html += '<s>' + argent(trouvee.compare_at_price) + '</s> ';
          }
          zonePrix.innerHTML = html + argent(trouvee.price);
        }

        // Photo : une variante qui porte sa propre image la fait passer dans la galerie.
        // Sans cela, choisir "Ferrari" laissait la cle noire a l'ecran alors que le
        // produit livre est rouge , l'erreur la plus couteuse d'une fiche a variantes.
        // srcset est retire : sinon le navigateur peut continuer a servir l'ancienne
        // image, la source la plus adaptee du jeu precedent restant valable.
        if (trouvee.featured_image && trouvee.featured_image.src) {
          var vue = $('[data-pdp-main] img');
          if (vue) {
            vue.removeAttribute('srcset');
            vue.removeAttribute('sizes');
            vue.src = trouvee.featured_image.src;
            if (trouvee.featured_image.alt) vue.alt = trouvee.featured_image.alt;
          }
        }

        // URL partageable, sans recharger : le client peut envoyer SA variante.
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', trouvee.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      });
    };

    options.forEach(function (i) { i.addEventListener('change', majuscule); });
  }

  /* -- Compteur du panier ------------------------------------------------
     Rafraichi apres retour sur la page (cache navigateur), sinon le compteur
     affiche une valeur perimee au bouton Precedent.                        */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        // La pastille se masque a zero : un "0" permanent est du bruit, et il laisse
        // croire que l'ajout au panier n'a pas fonctionne.
        $$('[data-cart-count]').forEach(function (n) {
          n.textContent = c.item_count;
          n.hidden = c.item_count === 0;
        });
      })
      .catch(function () {});
  });

  /* -- Fenetre de discussion ---------------------------------------------
     Aucune requete pour les reponses : elles sont deja dans la page, rangees dans des
     <template>. Cliquer une question clone la reponse et l'ajoute au fil. C'est ce qui
     permet a la fenetre de fonctionner hors ligne, sans cookie, et sans rien ajouter a
     la politique de securite du contenu.

     Le champ libre n'essaie PAS de comprendre : son formulaire pointe sur wa.me, donc ce
     qui est tape part sur WhatsApp, chez une personne. Un faux robot qui repond a cote
     est pire que pas de robot du tout.                                                */
  var chtRacine = $('[data-cht]');
  if (chtRacine) {
    var chtBulle = $('[data-cht-ouvrir]', chtRacine);
    var chtPanneau = $('[data-cht-panneau]', chtRacine);
    var chtFil = $('[data-cht-fil]', chtRacine);
    var chtChoix = $('[data-cht-choix]', chtRacine);
    var chtGroupe = $('[data-cht-groupe]', chtRacine);
    /* Defini plus bas, mais reference par la rangee de suite : en var, la declaration
       remonte, donc l'affectation tardive ne pose pas de probleme. */
    var chtOuvrirFormulaire = function () {};

    /* -- Etat d'ouverture, calcule sur les horaires reels --------------
       Le calcul se fait ICI et non cote serveur : une heure rendue en Liquid serait
       figee par le cache de page et afficherait « en ligne » a 4 h du matin.

       On lit l'heure DANS LE FUSEAU DE L'ATELIER, pas dans celui du visiteur : quelqu'un
       a New York doit voir « ferme » quand l'atelier dort, pas quand lui dort. D'ou le
       passage par Intl et non par getHours().                                          */
    var chtEtat = $('[data-cht-etat]', chtRacine);
    if (chtEtat && chtRacine.getAttribute('data-auto') === '1' && window.Intl) {
      var chtHoraire = function () {
        var fuseau = chtRacine.getAttribute('data-fuseau') || 'Europe/Paris';
        var parts;
        try {
          parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: fuseau, year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          }).formatToParts(new Date());
        } catch (err) { return null; }

        var chtV = {};
        parts.forEach(function (p) { chtV[p.type] = p.value; });
        /* Certaines implementations rendent encore « 24 » a minuit malgre h23. */
        if (chtV.hour === '24') chtV.hour = '00';
        return new Date(chtV.year + '-' + chtV.month + '-' + chtV.day + 'T' + chtV.hour + ':' + chtV.minute + ':00');
      };

      var chtMinutes = function (txt) {
        var m = String(txt || '').split(':');
        var h = parseInt(m[0], 10);
        if (isNaN(h)) return null;
        return h * 60 + (parseInt(m[1], 10) || 0);
      };

      var chtMajEtat = function () {
        var d = chtHoraire();
        if (!d) return;
        /* getDay rend 0 le dimanche ; on ramene sur la numerotation ISO, 1 = lundi et
           7 = dimanche, celle qui est expliquee dans le reglage. */
        var jour = d.getDay() || 7;
        var chtJours = (chtRacine.getAttribute('data-jours') || '').split(',');
        var ouvertJour = false;
        for (var chtI = 0; chtI < chtJours.length; chtI++) {
          if (parseInt(chtJours[chtI], 10) === jour) { ouvertJour = true; break; }
        }
        var debut = chtMinutes(chtRacine.getAttribute('data-ouvre'));
        var fin = chtMinutes(chtRacine.getAttribute('data-ferme'));
        var mnt = d.getHours() * 60 + d.getMinutes();
        var chtOuvert = ouvertJour && debut !== null && fin !== null && mnt >= debut && mnt < fin;

        chtEtat.textContent = chtRacine.getAttribute(chtOuvert ? 'data-ouvert-texte' : 'data-ferme-texte') || '';
        if (chtOuvert) chtEtat.removeAttribute('data-ferme');
        else chtEtat.setAttribute('data-ferme', '');
      };
      chtMajEtat();
      /* Une conversation peut durer : on repasse le cap de fermeture sans recharger. */
      window.setInterval(chtMajEtat, 60000);
    }

    /* -- Horodatage --
       Une pastille par prise de parole, pas une par bulle : dater chaque ligne alourdit
       sans rien apprendre. On n'en repose une que si plus d'une minute s'est ecoulee. */
    var chtDernierHoraire = 0;
    var chtPoserHeure = function () {
      var t = Date.now();
      if (t - chtDernierHoraire < 60000) return;
      chtDernierHoraire = t;
      var pastille = document.createElement('span');
      pastille.className = 'cht__heure';
      try {
        pastille.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', {
          hour: '2-digit', minute: '2-digit'
        }).format(new Date());
      } catch (err) {
        pastille.textContent = new Date().getHours() + 'h' + ('0' + new Date().getMinutes()).slice(-2);
      }
      chtFil.appendChild(pastille);
    };

    var chtBasculer = function (ouvrir) {
      chtPanneau.hidden = !ouvrir;
      chtBulle.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
      if (ouvrir) chtRacine.setAttribute('data-ouvert', '');
      else chtRacine.removeAttribute('data-ouvert');
      try { sessionStorage.setItem('cht-ouvert', ouvrir ? '1' : '0'); } catch (err) {}
      if (ouvrir) {
        var q = $('.cht__q', chtPanneau);
        if (q) q.focus();
      }
    };

    chtBulle.addEventListener('click', function () { chtBasculer(chtPanneau.hidden); });

    var chtX = $('[data-cht-fermer]', chtRacine);
    if (chtX) chtX.addEventListener('click', function () { chtBasculer(false); chtBulle.focus(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !chtPanneau.hidden) { chtBasculer(false); chtBulle.focus(); }
    });

    /* La fenetre reste ouverte d'une page a l'autre. Sans cela, cliquer un lien depuis
       une reponse refermait tout, et il fallait rouvrir pour poser la question suivante.
       sessionStorage et non localStorage : cela vaut pour la visite en cours, pas pour
       toutes les suivantes. */
    try {
      if (sessionStorage.getItem('cht-ouvert') === '1') chtBasculer(true);
    } catch (err) {}

    /* Deux suites apres chaque reponse : revenir aux questions, ou ecrire. C'est ce qui
       remplace la longue liste, et c'est aussi ce qui rattrape les 1 % que les reponses
       ecrites ne couvrent pas , sans obliger a chercher un bouton dans le pied. */
    var chtSuite = function () {
      var rangee = document.createElement('div');
      rangee.className = 'cht__suite';

      var retour = document.createElement('button');
      retour.type = 'button';
      retour.className = 'cht__q';
      retour.textContent = chtRacine.getAttribute('data-retour') || '';
      retour.addEventListener('click', function () {
        if (chtGroupe) {
          chtGroupe.hidden = false;
          chtFil.appendChild(chtGroupe);
        }
        rangee.remove();
        chtFil.scrollTop = chtFil.scrollHeight;
      });

      var ecrire = document.createElement('button');
      ecrire.type = 'button';
      ecrire.className = 'cht__q';
      ecrire.textContent = chtRacine.getAttribute('data-ecrire') || '';
      ecrire.addEventListener('click', function () { chtOuvrirFormulaire(); });

      rangee.appendChild(retour);
      rangee.appendChild(ecrire);
      return rangee;
    };

    if (chtChoix) {
      chtChoix.addEventListener('click', function (e) {
        /* « Laisser un message » est desormais le dernier bouton de la liste : son clic
           remonte ici, il faut donc le detourner avant de chercher une question. */
        if (e.target.closest('[data-cht-coord-ouvrir]')) { chtOuvrirFormulaire(); return; }
        var bouton = e.target.closest('[data-cht-q]');
        if (!bouton) return;
        var modele = $('[data-cht-rep="' + bouton.getAttribute('data-cht-q') + '"]', chtRacine);
        if (!modele) return;

        chtPoserHeure();

        /* La question posee remonte dans le fil, en bulle sombre. Sans elle, les reponses
           s'empilent sans qu'on sache a quoi elles repondent. */
        var pose = document.createElement('p');
        pose.className = 'cht__moi';
        pose.textContent = bouton.textContent.trim();
        chtFil.appendChild(pose);

        /* La reponse arrive dans un groupe complet , vignette et nom de l'expediteur ,
           comme le message d'accueil : c'est la meme voix, elle doit se presenter pareil. */
        var grp = document.createElement('div');
        grp.className = 'cht__grp';
        var vign = chtGroupe ? chtGroupe.querySelector('.cht__pastille--sm') : null;
        if (vign) grp.appendChild(vign.cloneNode(true));

        var bulles = document.createElement('div');
        bulles.className = 'cht__bulles';
        var rep = document.createElement('div');
        rep.className = 'cht__msg';
        var de = chtRacine.getAttribute('data-nom');
        if (de) {
          var etiq = document.createElement('span');
          etiq.className = 'cht__de';
          etiq.textContent = de;
          rep.appendChild(etiq);
        }
        rep.appendChild(modele.content.cloneNode(true));
        bulles.appendChild(rep);
        grp.appendChild(bulles);
        chtFil.appendChild(grp);

        /* La liste des questions DISPARAIT le temps de la reponse. La repousser en bas
           ne suffisait pas : dix boutons font plus de 300 px, ils remplissaient le cadre
           et la reponse restait hors du champ. Une fois la question posee, la liste n'a
           plus rien a dire , on la range et on propose deux suites seulement. */
        if (chtGroupe) chtGroupe.hidden = true;
        bulles.appendChild(chtSuite());

        /* On amene la QUESTION en haut du cadre : c'est elle qui ouvre l'echange, et la
           reponse se lit juste dessous.
           Mesure par rectangles et non par offsetTop : le seul ancetre positionne est
           .cht, pas le fil, donc offsetTop ne donne pas la position dans le defilement. */
        var chtDelta = pose.getBoundingClientRect().top - chtFil.getBoundingClientRect().top;
        chtFil.scrollTop = chtFil.scrollTop + chtDelta - 10;
      });
    }

    /* Le formulaire part sur WhatsApp tout seul (methode GET vers wa.me). On intercepte
       uniquement pour VIDER le champ : sans cela, revenir sur l'onglet laisse le message
       deja envoye dans la case, et on le renvoie deux fois. */
    var chtForm = $('[data-cht-form]', chtRacine);
    if (chtForm) {
      chtForm.addEventListener('submit', function () {
        window.setTimeout(function () { chtForm.reset(); }, 400);
      });
    }

    /* -- Laisser un message ---------------------------------------------
       Le formulaire est le VRAI formulaire de contact Shopify. Sans ce bloc il poste
       normalement sur /contact et Shopify affiche sa confirmation : rien n'est casse.
       Ici on l'envoie en arriere-plan pour que la personne reste dans la conversation.

       On lit le resultat sur le CODE HTTP et non sur le contenu de la reponse : Shopify
       renvoie la page de contact entiere, et y chercher un message de succes reviendrait
       a dependre d'une chaine traduite qui changera. */
    var chtCoord = $('[data-cht-coord]', chtRacine);
    var chtOuvrirCoord = $('[data-cht-coord-ouvrir]', chtRacine);
    if (chtCoord) {
      chtOuvrirFormulaire = function () {
        chtPoserHeure();
        if (chtGroupe) chtGroupe.hidden = true;
        chtCoord.hidden = false;
        chtFil.appendChild(chtCoord);
        var haut = chtCoord.getBoundingClientRect().top - chtFil.getBoundingClientRect().top;
        chtFil.scrollTop = chtFil.scrollTop + haut - 10;
        var prem = $('.cht__saisie', chtCoord);
        if (prem) prem.focus();
      };
      if (chtOuvrirCoord) chtOuvrirCoord.addEventListener('click', function () { chtOuvrirFormulaire(); });

      /* ENVOI NATIF, ET SURTOUT PAS EN ARRIERE-PLAN.
         Premiere version : on interceptait le submit et on postait en fetch pour garder
         la personne dans la conversation. Shopify repondait 400, « Missing CAPTCHA
         token », et AUCUN message n'est jamais parti , constate a l'essai.

         La protection anti-robots de Shopify pose son jeton en s'accrochant a l'envoi
         NATIF du formulaire. Le detourner, c'est le desarmer, et le serveur refuse. On
         laisse donc le navigateur faire, et on se contente de preparer le retour.

         `return_to` ramene sur la page d'ou l'on ecrivait plutot que sur /contact : sans
         lui, envoyer un message depuis une fiche produit ejectait de la fiche. */
      var chtEnvoi = $('[data-cht-envoi]', chtCoord);
      if (chtEnvoi) {
        var chtRetour = document.createElement('input');
        chtRetour.type = 'hidden';
        chtRetour.name = 'return_to';
        chtEnvoi.appendChild(chtRetour);

        chtEnvoi.addEventListener('submit', function () {
          if (!chtEnvoi.checkValidity()) return;
          chtRetour.value = window.location.pathname + window.location.search;
          try {
            sessionStorage.setItem('cht-ouvert', '1');
            sessionStorage.setItem('cht-envoye', '1');
          } catch (err) {}
        });
      }

      /* Au retour, on rouvre la conversation et on confirme dedans. Le drapeau est pose
         AVANT l'envoi et relu apres le rechargement : c'est ce qui donne l'impression
         d'une conversation continue malgre l'aller-retour par le serveur. */
      var chtEnvoye = false;
      try {
        chtEnvoye = sessionStorage.getItem('cht-envoye') === '1';
        if (chtEnvoye) sessionStorage.removeItem('cht-envoye');
      } catch (err) {}

      if (chtEnvoye || /[?&]contact_posted=true/.test(window.location.search)) {
        chtBasculer(true);
        chtPoserHeure();
        var chtMerci = document.createElement('div');
        chtMerci.className = 'cht__msg';
        chtMerci.textContent = chtEnvoi ? (chtEnvoi.getAttribute('data-cht-merci') || '') : '';
        chtFil.appendChild(chtMerci);
        chtMerci.appendChild(chtSuite());
        if (chtGroupe) chtGroupe.hidden = true;
        chtFil.scrollTop = chtFil.scrollHeight;

        /* On efface le parametre de l'URL : le laisser ferait reapparaitre le message a
           chaque rechargement, et il polluerait un lien partage. */
        if (window.history && window.history.replaceState) {
          var propre = window.location.pathname + window.location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '');
          window.history.replaceState({}, '', propre + window.location.hash);
        }
      }
    }
  }
})();
